module.exports = __webpack_public_path__ + "static/media/vimeo.89f63100.svg";